export const ERROR_CATEGORIES = [
  'CONTENT_ERROR', 'ASSET_LOAD_ERROR', 'STORAGE_ERROR', 'AUDIO_ERROR',
  'AD_ERROR', 'PRESENTATION_ERROR', 'CORE_INVARIANT_ERROR',
] as const;
export type ErrorCategory = (typeof ERROR_CATEGORIES)[number];
export type ErrorSeverity = 'FATAL' | 'RECOVERABLE';

export const classifyError = (category: ErrorCategory, required = true): ErrorSeverity => {
  if (category === 'ASSET_LOAD_ERROR') return required ? 'FATAL' : 'RECOVERABLE';
  if (category === 'STORAGE_ERROR' || category === 'AUDIO_ERROR' || category === 'AD_ERROR') return 'RECOVERABLE';
  return 'FATAL';
};

export class AppError extends Error {
  public constructor(public readonly category: ErrorCategory, message: string, public readonly required = true, options?: ErrorOptions) {
    super(message, options); this.name = 'AppError';
  }
  public get severity(): ErrorSeverity { return classifyError(this.category, this.required); }
}

export interface DisposableBattle { dispose(): void }
export const disposeFatalBattle = (battle: DisposableBattle | null, clearTransients: () => void): void => {
  try { clearTransients(); } finally { battle?.dispose(); }
};
